module.exports = __webpack_public_path__ + "img/instagram-brands.f288991d.svg";